/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import * as Types from '../../../types/schema.generated';

import gql from 'graphql-tag';
import * as VueApolloComposable from '@vue/apollo-composable';
import * as VueCompositionApi from 'vue';
export type ReactiveFunction<TParam> = () => TParam;
export type CoverageViewDocumentFragment = { __typename: 'SolicitorCloudCoverageDocument', id: string, title: string, createdAt: DateTimeString, updatedAt: DateTimeString, currentDocumentVersion: { id: string, publishedAt: DateTimeString } | null };

export type CoverageViewCorporationFragment = { id: string, name: string, documents: Array<
    | { __typename: 'SolicitorCloudCoverageDocument', id: string, title: string, createdAt: DateTimeString, updatedAt: DateTimeString, currentDocumentVersion: { id: string, publishedAt: DateTimeString } | null }
    | Record<PropertyKey, never>
  > };

export type GetCoverageViewDocumentFileUrlQueryVariables = Exact<{
  ids: Array<string | number> | string | number;
}>;


export type GetCoverageViewDocumentFileUrlQuery = { solicitorCloudCoverageDocumentVersionByIds: Array<{ fileUrl: string }> };

export const CoverageViewDocumentFragmentDoc = gql`
    fragment CoverageViewDocument on SolicitorCloudCoverageDocument {
  __typename
  id
  title
  createdAt
  updatedAt
  currentDocumentVersion {
    id
    publishedAt
  }
}
    `;
export const CoverageViewCorporationFragmentDoc = gql`
    fragment CoverageViewCorporation on SolicitorCloudCorporation {
  id
  name
  documents {
    ... on SolicitorCloudCoverageDocument {
      ...CoverageViewDocument
    }
  }
}
    ${CoverageViewDocumentFragmentDoc}`;
export const GetCoverageViewDocumentFileUrlDocument = gql`
    query getCoverageViewDocumentFileUrl($ids: [ID!]!) {
  solicitorCloudCoverageDocumentVersionByIds(ids: $ids) {
    fileUrl
  }
}
    `;

/**
 * __useGetCoverageViewDocumentFileUrlQuery__
 *
 * To run a query within a Vue component, call `useGetCoverageViewDocumentFileUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoverageViewDocumentFileUrlQuery` returns an object from Apollo Client that contains result, loading and error properties
 * you can use to render your UI.
 *
 * @param variables that will be passed into the query
 * @param options that will be passed into the query, supported options are listed on: https://v4.apollo.vuejs.org/guide-composable/query.html#options;
 *
 * @example
 * const { result, loading, error } = useGetCoverageViewDocumentFileUrlQuery({
 *   ids: // value for 'ids'
 * });
 */
export function useGetCoverageViewDocumentFileUrlQuery(variables: GetCoverageViewDocumentFileUrlQueryVariables | VueCompositionApi.Ref<GetCoverageViewDocumentFileUrlQueryVariables> | ReactiveFunction<GetCoverageViewDocumentFileUrlQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCoverageViewDocumentFileUrlQuery, GetCoverageViewDocumentFileUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCoverageViewDocumentFileUrlQuery, GetCoverageViewDocumentFileUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCoverageViewDocumentFileUrlQuery, GetCoverageViewDocumentFileUrlQueryVariables>> = {}) {
  return VueApolloComposable.useQuery<GetCoverageViewDocumentFileUrlQuery, GetCoverageViewDocumentFileUrlQueryVariables>(GetCoverageViewDocumentFileUrlDocument, variables, options);
}
export function useGetCoverageViewDocumentFileUrlLazyQuery(variables?: GetCoverageViewDocumentFileUrlQueryVariables | VueCompositionApi.Ref<GetCoverageViewDocumentFileUrlQueryVariables> | ReactiveFunction<GetCoverageViewDocumentFileUrlQueryVariables>, options: VueApolloComposable.UseQueryOptions<GetCoverageViewDocumentFileUrlQuery, GetCoverageViewDocumentFileUrlQueryVariables> | VueCompositionApi.Ref<VueApolloComposable.UseQueryOptions<GetCoverageViewDocumentFileUrlQuery, GetCoverageViewDocumentFileUrlQueryVariables>> | ReactiveFunction<VueApolloComposable.UseQueryOptions<GetCoverageViewDocumentFileUrlQuery, GetCoverageViewDocumentFileUrlQueryVariables>> = {}) {
  return VueApolloComposable.useLazyQuery<GetCoverageViewDocumentFileUrlQuery, GetCoverageViewDocumentFileUrlQueryVariables>(GetCoverageViewDocumentFileUrlDocument, variables, options);
}
export type GetCoverageViewDocumentFileUrlQueryCompositionFunctionResult = VueApolloComposable.UseQueryReturn<GetCoverageViewDocumentFileUrlQuery, GetCoverageViewDocumentFileUrlQueryVariables>;